import React, { useState } from 'react';
import { CheckIcon, FlagIcon, ShieldOffIcon } from 'lucide-react';
import { Button } from '../ui/Button';
import { Modal } from '../ui/Modal';
import { Textarea } from '../ui/Field';
import { ChoiceGroup } from '../ui/ChoiceGroup';
import { useAccount } from '../../contexts/AccountContext';
const REASONS = ['Fraud or scam', 'Misleading details', 'Duplicate', 'Harassment', 'Other'] as const;
interface ReportControlsProps {
  subject: string;
  surface: 'listing' | 'roommate profile' | 'job' | 'event' | 'review' | 'profile' | 'group' | 'message';
  allowBlock?: boolean;
  size?: 'sm' | 'md';
}
export function ReportControls({
  subject,
  surface,
  allowBlock = false,
  size = 'sm'
}: ReportControlsProps) {
  const {
    reports,
    addReport,
    blocked,
    toggleBlock
  } = useAccount();
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState<(typeof REASONS)[number]>('Fraud or scam');
  const [detail, setDetail] = useState('');
  const reported = reports.includes(subject);
  const isBlocked = blocked.includes(subject);
  return <div className="flex items-center gap-2" data-id="element-5498" data-mp="2i2tjo22zir8g">
      {allowBlock && <Button size={size} variant="ghost" icon={<ShieldOffIcon className="h-3.5 w-3.5" data-id="element-5500" data-mp="2wx7z5sncbiid" />} onClick={() => toggleBlock(subject)} data-id="element-5499" data-mp="2wz16zb9ow8ry">
          {isBlocked ? 'Unblock' : 'Block'}
        </Button>}
      {reported ? <span className="inline-flex items-center gap-1.5 text-[13px] font-medium text-ok-700" data-id="element-5501" data-mp="35xwcsm8tnguq">
          <CheckIcon className="h-3.5 w-3.5" data-id="element-5502" data-mp="30ytinwudqv1j" />
          Reported
        </span> : <Button size={size} variant="ghost" icon={<FlagIcon className="h-3.5 w-3.5" data-id="element-5504" data-mp="3arqtrhx1lhq4" />} onClick={() => setOpen(true)} data-id="element-5503" data-mp="3fp0pffb0ypme">
          Report
        </Button>}

      <Modal open={open} onClose={() => setOpen(false)} title={`Report this ${surface}`} description={`${subject} — reports go to the Campuzon trust and safety queue. Nothing is shared with the ${surface} owner.`} footer={<>
            <Button variant="secondary" onClick={() => setOpen(false)} data-id="element-5506" data-mp="maa5cntyqv4">
              Cancel
            </Button>
            <Button variant="primary" onClick={() => {
        addReport(subject);
        setOpen(false);
        setDetail('');
      }} data-id="element-5507" data-mp="5isdc83iih5c">
              Submit report
            </Button>
          </>} data-id="element-5505" data-mp="3ooe3kla3g2dg">
        <div className="space-y-4" data-id="element-5508" data-mp="jafb6cd3rxq8">
          <ChoiceGroup label="Reason" options={REASONS} value={reason} onChange={setReason} data-id="element-5509" data-mp="obd15b4ctw2a" />
          <div data-id="element-5510" data-mp="tafx862cwry4">
            <label htmlFor="report-detail" className="mb-1.5 block text-[13px] font-medium text-ink" data-id="element-5511" data-mp="tazh3sbkhqes">
              What happened?
            </label>
            <Textarea id="report-detail" rows={4} value={detail} onChange={event => setDetail(event.target.value)} placeholder="Dates, amounts requested, screenshots you can provide — anything that helps a reviewer." data-id="element-5512" data-mp="2v1j8mxk2majq" />
          </div>
        </div>
      </Modal>
    </div>;
}